import React, {useEffect, useRef, useState} from 'react';
import {Dialog, Button, Typography, Stack, Box} from '@mui/material';
import {useCallContext} from '../CallContext';
// import {openChatWithUser} from '../globalChatManager';
import CallIcon from '@mui/icons-material/Call';
import CallEndIcon from '@mui/icons-material/CallEnd';
import incomingCallSoundUrl from '../../../assets/sounds/incomingCallSound.mp3';

export const GlobalIncomingCallModal: React.FC = () => {
    const {state, incomingCaller, acceptCall, rejectCall} = useCallContext();

    const [dismissed, setDismissed] = useState(false);
    const shouldShow = !dismissed && state === 'receiving' && !!incomingCaller;

    const audioRef = useRef<HTMLAudioElement | null>(null);
    const [autoplayBlocked, setAutoplayBlocked] = useState(false);

    useEffect(() => {
        if (!shouldShow) return;
        const a = new Audio(incomingCallSoundUrl);
        a.loop = true;
        a.preload = 'auto';
        audioRef.current = a;

        a.play()
            .then(() => setAutoplayBlocked(false))
            .catch(() => setAutoplayBlocked(true));

        return () => {
            a.pause();
            a.currentTime = 0;
            audioRef.current = null;
        };
    }, [shouldShow]);

    useEffect(() => {
        if (state !== 'receiving') setDismissed(false);
    }, [state]);

    const stopSound = () => {
        const a = audioRef.current;
        if (!a) return;
        a.pause();
        a.currentTime = 0;
        audioRef.current = null;
    };

    const onAnswer = () => {
        stopSound();
        // if (incomingCaller) openChatWithUser(incomingCaller);
        acceptCall();             
        setDismissed(true);
      };

    const onReject = () => {
        stopSound();
        rejectCall();
        setDismissed(true);
    };

    const tryEnableSound = async () => {
        try {
            await audioRef.current?.play();
            setAutoplayBlocked(false);
        } catch {}
    };

    if (!shouldShow) return null;

    return (
        <Dialog
            open
            fullWidth
            maxWidth='xs'
            PaperProps={{sx: {borderRadius: 3, overflow: 'hidden'}}}
        >
            <Box sx={{bgcolor: 'primary.main', color: '#fff', p: 3, textAlign: 'center'}}>
                <CallIcon sx={{fontSize: 48, mb: 1}} />
                <Typography
                    variant='h5'
                    fontWeight='bold'
                >
                    Входящий звонок
                </Typography>
                <Typography
                    variant='body1'
                    sx={{mt: 1, opacity: 0.9}}
                >
                    {incomingCaller}
                </Typography>
                {autoplayBlocked && (
                    <Button
                        onClick={tryEnableSound}
                        variant='outlined'
                        size='small'
                        sx={{mt: 2, color: '#fff', borderColor: 'rgba(255,255,255,.6)'}}
                    >
                        Включить звук
                    </Button>
                )}
            </Box>

            <Box sx={{p: 3}}>
                <Stack
                    direction='row'
                    justifyContent='space-around'
                    spacing={3}
                >
                    <Button
                        onClick={onReject}
                        variant='contained'
                        color='error'
                        size='large'
                        startIcon={<CallEndIcon />}
                        sx={{borderRadius: '50px', px: 4, py: 1.5, fontSize: '1.1rem'}}
                    >
                        Отклонить
                    </Button>
                    <Button
                        onClick={onAnswer}
                        variant='contained'
                        color='success'
                        size='large'
                        startIcon={<CallIcon />}
                        sx={{borderRadius: '50px', px: 4, py: 1.5, fontSize: '1.1rem'}}
                    >
                        Ответить
                    </Button>
                </Stack>
            </Box>
        </Dialog>
    );
};
